<template>
  <v-container fluid>
    <v-card outlined>
      <v-card-subtitle>
        Puedes <strong>buscar</strong> por folio y rango de fechas
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="8" sm="6" md="3" lg="2" xl="2">
            <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field outlined dense v-model="dateStart" label="Fecha de inicio" prepend-icon="mdi-calendar"
                  readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="dateStart" no-title scrollable :max="today" @input="menuStart = false"
                type="month" locale="es"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" xs="8" sm="6" md="3" lg="2" xl="2">
            <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field outlined dense v-model="dateEnd" label="Fecha de fin" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="dateEnd" no-title scrollable :min="dateStart" @input="menuEnd = false"
                type="month" locale="es"></v-date-picker>
            </v-menu>
          </v-col>
          <!-- Campo de búsqueda -->
          <v-col cols="12" m="3" md="3" lg="3">
            <v-text-field clearable class="col" v-model="Folio" label="Folio" outlined dense @change="changeSearch"
              @keyup.enter="Buscar">
            </v-text-field>
          </v-col>
          <!-- Botón de búsqueda -->
          <v-col>
            <v-btn color="azulfuerte" @click="Buscar" dark>
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <cards-urgencias :urgencias="this.urgencias"></cards-urgencias>
<!-- 
    

    <list-pagos :isOpen.sync="dialogPagos" :Membresia="this.MembresiaSelec"></list-pagos> -->
  </v-container>
</template>
<script>
export default {
  computed: {
    mem() {
      return this.$route.params.mem;
    }
  },
  components: {
    CardsUrgencias: () => import('@/components/CardsUrgenciasComponent')
    //ListPagos: () => import('@/components/ListPagoComponent.vue')
  },
  created() {
    this.Folio = this.$route.params.folio || null;
    //if(this.Folio){
    this.getData()
    //}
  },
  data() {
    return {
      dateStart: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 7),
      dateEnd: new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString().substr(0, 7),
      today: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10), //new Date().toISOString().substr(0, 10) // Fecha de hoy en formato YYYY-MM-DD

      Folio: null,
      urgencias: [],

      isModLisPagos: false,
      dialogBeneficiados: false,
      dialogPagoShow: false,
      dialogPases: false,
      isModalCitas: false,


      MembresiaSelect: {},


      NombreMem: null,
      verOptDownloadCole: false,
      contratos: [],
      idagenteSelect: null,
      idcolectividadSelect: null,
      tableActions: [
        //'BENEFICIADOS',
        'RECIBOS',
        'PASES MEDICOS',
        'TARJETA DIGITAL',
        //'URGENCIAS',
        //'CONTRATO'
      ],
      menuStart: false,
      menuEnd: false,
    }
  },
  methods: {
    crearCrearCita(cita) {
      if (cita.beneficiado.Id && cita.especialidad && cita.medico.IdMedico && cita.membresia) {
        this.$http.post('membresia/citamedica', {
          idMem: cita.membresia,
          idEsp: cita.especialidad,
          idMed: cita.medico.IdMedico,
          idBen: cita.beneficiado.Id
        })
          .then(response => {
            if (response.status === 200) {
              this.actualizaNumCitas(cita.membresia)
              this.$swal.fire({
                position: 'top-end',
                title: 'Correcto',
                text: 'Su pase médico se genero correctamente',
                icon: 'success',
                confirmButtonText: 'Cerrar',
                showCloseButton: false,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false
              })
              this.$refs.modalPaseMedico.reloadTable()
            } else {
              this.isModalCita = false
              this.$swal.fire({
                title: 'Infomación',
                text: 'No tienes pases sificientes puedes hacer una recarga de 5 a un costo especial contacta a tu agente.',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                backdrop: false
              });
            }
          })
          .catch(() => {
          })
          .finally(() => {
          });

      } else {
        this.especialidad = ''
        this.medico = ''
        this.beneficiado = ''
        this.$swal.fire({
          // position: 'top-end',
          title: 'Infomación',
          text: `Selecciona una especialidad, un médico y para quien será el pase.`,
          icon: 'warning',
          confirmButtonText: 'Cerrar',
          showCloseButton: false,
          // timer: 1500,
          backdrop: false,
        })
      }
    },
    getData() {
      this.$http.get(`urgencia/mensuales?fecIni=${this.dateStart || ''}&fecFin=${this.dateEnd || ''}&folio=${this.Folio || ''}`)
        .then(response => {
          if (response.status === 200) {
            this.urgencias = response.data
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
    changeColectividad(value) {
      this.idcolectividadSelect = value
      this.verOptDownloadCole = value !== null;
      if (value) {
        this.idagenteSelect = null
        this.NombreMem = null
      }
    },
    changeAgent(value) {
      this.idagenteSelect = value
      if (value) {
        this.idcolectividadSelect = null
        this.NombreMem = null
      }
    },
    actualizaNumCitas(membresiaId) {
      this.$http.get(`Membresia/Numerocitas${this.MembresiaSelect.Id}`)
        .then(response => {
          if (response.status === 200) {
            const index = this.contratos.findIndex(item => item.Id === membresiaId);
            if (index !== -1) {
              this.contratos[index].NumCitas = response.data[0].NumCitas;
            }
            this.MembresiaSelect.NumCitas = response.data[0].NumCitas
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
    Buscar() {
      this.getData()
    },
    changeSearch() {
      this.idcolectividadSelect = null
      this.idagenteSelect = null
    },
    onActionSelected(action, item) {
      this.MembresiaSelect = { ...item }
      switch (action) {
        case 'BENEFICIADOS':
          this.dialogBeneficiados = true
          break;
        case 'PASES MEDICOS':
          this.dialogPases = true
          break;
        case 'RECIBOS':
          this.dialogPagos = true
          break;
        case 'TARJETA DIGITAL':
          this.$onDescargaTarjeta(item.Id)
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>